module.exports = __webpack_public_path__ + "img/thumbnail_SouthernWhiteRhino_j_normal.7f9c6fd2.png";